<template>
    <div class="d-flex flex-wrap">
        <div class="d-flex justify-content-between" style="width:100%">
            <b-button
                variant="link"
                v-if="!item.read_at"
                @click.prevent="verTarefa()"
                ><small>Ver tarefa</small>
            </b-button>
            <small v-if="item.read_at"
                ><i class="fas fa-check"></i> Tarefa visualizada em
                {{ moment(item.read_at).format("LLLL") }}
            </small>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object
    },
    methods: {
        verTarefa() {
            this.$root.$emit("verTarefa", this.item);
            this.$emit("read", true);
        }
    }
};
</script>
